import React, { useCallback, useMemo, useState } from 'react';
import { AppView } from 'design-system/AppView';
import { StyleSheet, TouchableWithoutFeedback, View, } from 'react-native';
import Animated from 'react-native-reanimated';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import { useAppSelector } from 'store/hooks';
import FakeSearchBar from 'design-system/FakeSearchBar';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useHeaderHeight } from 'hooks';
import { useMarginBottom } from 'hooks/useMarginBottom';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { rem, SCREEN_BOTTOM_PADDING, StatusBar } from 'design-system';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb } from '../../../constants';
import HelpItems from '../components/HelpItems';
import RecommendedArticles from '../components/RecommendedArticles';
import { useHelpArticlesConfig } from '../hooks/useHelpArticlesConfig';
export const HelpScreen = withAnimatedNavigationHeader(({ navigation, route, onScroll, scrollY }) => {
    const { articlesKey } = route.params;
    const { omitFaq, relatedTopicArticles, relatedTopicsTitle, showSeeAll } = useHelpArticlesConfig(articlesKey);
    const firstName = useAppSelector((store) => store.user.user.firstName);
    const title = `Hi ${firstName}, how can we help you?`;
    const [infoHeaderHeight, setInfoHeaderHeight] = useState(0);
    const headerHeight = useHeaderHeight();
    const { top } = useSafeAreaInsets();
    const onInfoHeaderLayout = (event) => {
        const { height } = event.nativeEvent.layout;
        setInfoHeaderHeight(height);
    };
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', SCREEN_BOTTOM_PADDING, paddingHorizontalStyle);
    const goToSearch = useCallback(() => {
        navigation.navigate('SearchHelpArticles', {
            searchBarY: Math.max(top + rem(8), infoHeaderHeight + headerHeight - scrollY.get()),
            articlesKey,
        });
    }, [top, infoHeaderHeight, headerHeight, scrollY, articlesKey]);
    const SearchHeader = useMemo(() => (<TouchableWithoutFeedback onPress={goToSearch}>
          <View pointerEvents="box-only">
            <FakeSearchBar placeholder="Search" style={styles.searchBar}/>
          </View>
        </TouchableWithoutFeedback>), [goToSearch]);
    return (<AppView withFrame={false}>
        <Animated.ScrollView onScroll={onScroll} scrollEventThrottle={16} contentContainerStyle={contentContainerStyle}>
          <StatusBar barStyle="dark-content" animated/>
          <ScreenInfoHeader title={title} onLayout={onInfoHeaderLayout} style={{ paddingBottom: rem(16) }}/>
          {SearchHeader}
          <RecommendedArticles headerTitle={relatedTopicsTitle} articles={relatedTopicArticles} onSeeAllPress={showSeeAll ? goToSearch : undefined} omitFaq={omitFaq}/>
          <HelpItems />
        </Animated.ScrollView>
      </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
    hideTitleOnScroll: true,
    title: 'Help',
    headerTitleStyle: isWeb
        ? {
            fontSize: 18,
            fontWeight: '600',
        }
        : undefined,
}));
const styles = StyleSheet.create({
    searchBar: {
        marginBottom: rem(0),
    },
});
